"use client"

import { useState, useEffect } from "react"
import { Autocomplete, Box, TextField, Typography } from "@mui/material"
import { useNotification } from "../../contexts/NotificationContext"
import { getActiveOrganizations } from "../../services/organization.service"

const OrganizationFilter = ({ value, onChange, label, placeholder }) => {
  const { showNotification } = useNotification()
  const [organizations, setOrganizations] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await getActiveOrganizations()
        setOrganizations(response.data)
      } catch (error) {
        showNotification(error.message || "Failed to fetch organizations", "error")
      } finally {
        setLoading(false)
      }
    }
    fetchOrganizations()
  }, [])

  return (
    <Autocomplete
      multiple
      options={organizations}
      loading={loading}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      getOptionLabel={(organization) => organization.name}
      isOptionEqualToValue={(option, selected) => option._id === selected._id}
      renderOption={(props, organization) => (
        <li {...props} key={organization._id}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" noWrap>
              {organization.name}
            </Typography>
            {organization.slug && (
              <Typography variant="caption" color="text.secondary" noWrap component="div">
                {organization.slug}
              </Typography>
            )}
          </Box>
        </li>
      )}
      renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} />}
    />
  )
}

export default OrganizationFilter
